<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/PvYmXT/tc-custom/9781614237945.jpg?1679071539961" alt="This image is the cover for the book History of Gunstock: Skiing the Belknap Mountains, Sports"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">History of Gunstock: Skiing the Belknap Mountains, Sports
      </h1>
      <p class="bookDescription body article font2">
        <p>Before it became home to generations of skiers, Gunstock Mountain began as a Works Progress Administration recreation project during the Great Depression that transformed the small farming community of Gilford into one of central New Hampshire's most renowned skiing resorts. Join local ski historian Carol Anderson as she takes on the triumphs and defeats of four high-altitude jumps and the history of the snowy trails of the Gunstock Mountain Resort. Approaching its seventy-fifth anniversary, Gunstock has molded the careers of champion skiers and Olympians, including two-time silver medalist Penny Pitou, ski icon T. Gary Allen and the ski jumping sensation Torger Tokle. Anderson pays tribute to those individuals who have worked, skied or played a part in this iconic mountain of the Lakes Region.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Carol Lee Anderson
      </h2>
      
      <p class="authorDescription body article">Carol Anderson is a member and director of Gilford's Thompson-Ames Historical Society. She is also a member of the Laconia Historical & Museum Society, NH Preservation Alliance and New England Ski Museum. She wrote Gunstock Skiing, which won the 2012 Skade Award.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?89db515c